export default "__VITE_ASSET__F8miEvX4__"